import {UploadedFile} from '_metronic/helpers/components/uploadTypes'
import {ReactNode, Dispatch, SetStateAction} from 'react'
import {IInvoiceFav} from '../../apps/invoice-management/invoices-list/InvoiceTypeSelect'
import type {AccountCompletionFlags, CompletionMoment} from './accountCompletion'
import type {DeviceLimitFlag} from './deviceLimit'
import type {StaffSessionModel} from './staffAccess'

export type {StaffSessionModel} from './staffAccess'

export interface UserAddressModel {
  addressLine: string
  city: string
  state: string
  postCode: string
}

export interface UserCommunicationModel {
  email: boolean
  sms: boolean
  phone: boolean
}

export interface UserEmailSettingsModel {
  emailNotification?: boolean
  sendCopyToPersonalEmail?: boolean
  activityRelatesEmail?: {
    youHaveNewNotifications?: boolean
    youAreSentADirectMessage?: boolean
    someoneAddsYouAsAsAConnection?: boolean
    uponNewOrder?: boolean
    newMembershipApproval?: boolean
    memberRegistration?: boolean
  }
  updatesFromKeenthemes?: {
    newsAboutKeenthemesProductsAndFeatureUpdates?: boolean
    tipsOnGettingMoreOutOfKeen?: boolean
    thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean
    newsAboutStartOnPartnerProductsAndOtherServices?: boolean
    tipsOnStartBusinessProducts?: boolean
  }
}

export interface UserSocialNetworksModel {
  linkedIn: string
  facebook: string
  twitter: string
  instagram: string
}

export interface AuthModel {
  fn: string
  ftn: string
  ln: string
  bdt: string
  un: string
  id: number
  nid: string
  rl: number
  //lan: 'fa' | 'en'
  cpl?: UserCompanyModel[]
  cpi: number
  tk: string
  mbl: string
  pic: UploadedFile[]
  tlg: number
  infv: IInvoiceFav[]
  inmd: number
  support?: SupportSessionModel
  // A session opened from the CRM's «پنل» button: the sections the CRM role grants (backend 1.0.0.758+, staffAccess.ts).
  staff?: StaffSessionModel | null
  sso?: SsoLoginModel
  ticketingEnabled?: boolean
  isOnPremises?: boolean
  OneRowQueueInvoiceReport?: boolean
  // The user has no username or no password yet and signs in with an SMS code only.
  credentialSetupRequired?: boolean
  // The user signed in with a still-valid temporary password and has not set their own yet.
  temporaryPasswordInUse?: boolean
  // The server builds each request in the business its tab names (backend 1.0.0.747+, tabBusiness.ts).
  bpt?: boolean
  // What the account still lacks before it may be used (backend 1.0.0.757+); null when complete (accountCompletion.ts).
  accountCompletion?: AccountCompletionFlags | null
  // While the 8 hours given during an SMS outage last: when the mobile must be registered by.
  mobileDeferredUntil?: CompletionMoment | null
  // This sign-in is past the two devices of its kind (backend 1.0.0.757+): «انتخاب دستگاه» first (deviceLimit.ts).
  deviceLimit?: DeviceLimitFlag | null
}

// Present when the session was opened through the tax-folder SSO (کارپوشه). The backend masks
// nid for display; the real identifier stays on the server with the session.
export interface SsoLoginModel {
  id: number
  nid: string
}

export interface SupportSessionModel {
  session_type: 'support'
  support_mode: 'readonly'
  session_id: string
  operator_id: number
  operator_name: string
  crm_user_id: number
  crm_account_id: number
  company_id: number
  company_name: string
  issued_at: number
  expires_at: number
  source_ip?: string
}

export interface UserCompanyModel {
  id: number
  nm: string
  nid: string
  frm?: number[]
  vnc?: boolean
}

export type RegisterationContextProps = {
  helpPlace: ReactNode
  setHelpPlace: Dispatch<SetStateAction<ReactNode>>
}
export const initialRegistration: RegisterationContextProps = {
  helpPlace: '',
  setHelpPlace: () => {},
}
